import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'hcon-spinner',
  template: `<div class="spinner"></div>`,
  styleUrls: ['./spinner.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpinnerComponent {}
